import React from 'react';

const Apps = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="gradient-bg text-white section-padding">
        <div className="container-custom text-center">
          <h1 className="text-5xl font-display font-bold mb-6">
            IBT Sports Apps
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Take your sports streaming experience anywhere with our premium mobile and smart TV apps. 
            Available on all major platforms with seamless sync across devices.
          </p>
        </div>
      </section>

      {/* App Overview */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Mobile Apps */}
            <div>
              <h2 className="text-4xl font-display font-bold text-ibt-gray mb-8">
                Mobile Applications
              </h2>
              <div className="space-y-6">
                <p className="text-lg text-gray-600 leading-relaxed">
                  Stream your favorite sports on the go with our feature-rich mobile apps. 
                  Enjoy 4K quality, offline downloads, and real-time notifications on iOS and Android.
                </p>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* iOS App */}
                  <div className="bg-black rounded-2xl p-6 text-white hover:bg-gray-800 transition duration-300 cursor-pointer">
                    <div className="flex items-center mb-4">
                      <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center mr-4">
                        <svg className="w-8 h-8 text-black" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                        </svg>
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold">iOS App</h3>
                        <p className="text-gray-300 text-sm">iPhone & iPad</p>
                      </div>
                    </div>
                    <button className="w-full bg-white text-black py-3 px-4 rounded-lg font-semibold hover:bg-gray-100 transition duration-300">
                      Download on App Store
                    </button>
                  </div>

                  {/* Android App */}
                  <div className="bg-green-600 rounded-2xl p-6 text-white hover:bg-green-700 transition duration-300 cursor-pointer">
                    <div className="flex items-center mb-4">
                      <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center mr-4">
                        <svg className="w-8 h-8 text-green-600" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M17.523 15.3414c-.5511 0-.9993-.4486-.9993-.9997s.4482-.9993.9993-.9993c.5511 0 .9993.4482.9993.9993.0001.5511-.4482.9997-.9993.9997m-11.046 0c-.5511 0-.9993-.4486-.9993-.9997s.4482-.9993.9993-.9993c.5511 0 .9993.4482.9993.9993 0 .5511-.4482.9997-.9993.9997m11.4045-6.02l1.9973-3.4592a.416.416 0 00-.1521-.5676.416.416 0 00-.5676.1521l-2.0223 3.503C15.5902 8.2439 13.8533 7.8508 12 7.8508s-3.5902.3931-5.1367 1.0989L4.841 5.4467a.4161.4161 0 00-.5677-.1521.4157.4157 0 00-.1521.5676l1.9973 3.4592C2.61 10.2718.8995 12.8447.8995 15.7995c0 .1873.0008.3733.0023.5588v6.6334C.9018 24.8814 2.1204 26.1 3.6107 26.1h16.7785c1.4903 0 2.7089-1.2186 2.7089-2.7083v-6.6334c.0015-.1855.0023-.3715.0023-.5588 0-2.9548-1.7105-5.5277-4.2098-6.4581"/>
                        </svg>
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold">Android App</h3>
                        <p className="text-green-100 text-sm">Android Devices</p>
                      </div>
                    </div>
                    <button className="w-full bg-white text-green-600 py-3 px-4 rounded-lg font-semibold hover:bg-gray-100 transition duration-300">
                      Get it on Google Play
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile Mockup */}
            <div className="relative">
              <div className="relative z-10 max-w-sm mx-auto">
                <div className="bg-black rounded-3xl p-4 shadow-2xl">
                  <div className="bg-white rounded-2xl overflow-hidden">
                    {/* Status Bar */}
                    <div className="bg-black text-white text-xs p-2 flex justify-between items-center">
                      <span>9:41</span>
                      <div className="flex space-x-1">
                        <div className="w-4 h-2 bg-white rounded-sm"></div>
                        <div className="w-4 h-2 bg-white rounded-sm"></div>
                        <div className="w-4 h-2 bg-white rounded-sm"></div>
                      </div>
                    </div>
                    
                    {/* App Content */}
                    <div className="p-4">
                      <div className="bg-gradient-to-r from-ibt-blue to-ibt-red rounded-lg p-4 text-white mb-4">
                        <h3 className="font-bold text-lg">Live Now</h3>
                        <p className="text-sm opacity-90">NFL Championship</p>
                      </div>
                      
                      <div className="space-y-3">
                        <div className="flex items-center justify-between bg-gray-100 rounded-lg p-3">
                          <div className="flex items-center">
                            <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center mr-3">
                              <span className="text-white text-xs font-bold">🏈</span>
                            </div>
                            <span className="font-semibold text-sm">NFL Games</span>
                          </div>
                          <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center">
                            <span className="text-white text-xs">3</span>
                          </div>
                        </div>
                        
                        <div className="flex items-center justify-between bg-gray-100 rounded-lg p-3">
                          <div className="flex items-center">
                            <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center mr-3">
                              <span className="text-white text-xs font-bold">🏀</span>
                            </div>
                            <span className="font-semibold text-sm">NBA Games</span>
                          </div>
                          <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center">
                            <span className="text-white text-xs">5</span>
                          </div>
                        </div>
                        
                        <div className="flex items-center justify-between bg-gray-100 rounded-lg p-3">
                          <div className="flex items-center">
                            <div className="w-8 h-8 bg-gray-700 rounded-full flex items-center justify-center mr-3">
                              <span className="text-white text-xs font-bold">🏒</span>
                            </div>
                            <span className="font-semibold text-sm">NHL Games</span>
                          </div>
                          <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center">
                            <span className="text-white text-xs">2</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Background Elements */}
              <div className="absolute -top-8 -right-8 w-32 h-32 bg-ibt-blue bg-opacity-10 rounded-full blur-xl"></div>
              <div className="absolute -bottom-8 -left-8 w-40 h-40 bg-ibt-red bg-opacity-10 rounded-full blur-xl"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Smart TV Apps */}
      <section className="section-padding bg-ibt-light-gray">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* TV Mockup */}
            <div className="relative order-2 lg:order-1">
              <div className="bg-black rounded-2xl p-8 shadow-2xl">
                <div className="bg-gray-900 rounded-lg aspect-video flex items-center justify-center relative overflow-hidden">
                  {/* TV Content */}
                  <div className="absolute inset-0 bg-gradient-to-br from-green-700 to-green-900"></div>
                  <div className="relative z-10 text-center text-white">
                    <div className="text-6xl mb-4">🏈</div>
                    <div className="text-2xl font-bold mb-2">LIVE NFL</div>
                    <div className="text-lg">Championship Game</div>
                  </div>
                  
                  {/* TV UI Elements */}
                  <div className="absolute bottom-4 left-4 bg-black bg-opacity-70 rounded-lg p-3">
                    <div className="text-white text-sm">
                      <div className="font-bold">Chiefs vs Bills</div>
                      <div className="text-xs opacity-80">Q2 - 7:32</div>
                    </div>
                  </div>
                  
                  <div className="absolute top-4 right-4 bg-red-600 text-white text-sm px-3 py-1 rounded-full">
                    LIVE
                  </div>
                </div>
                
                {/* TV Stand */}
                <div className="mt-4 flex justify-center">
                  <div className="w-24 h-4 bg-gray-800 rounded-b-lg"></div>
                </div>
              </div>
            </div>

            {/* Smart TV Content */}
            <div className="order-1 lg:order-2">
              <h2 className="text-4xl font-display font-bold text-ibt-gray mb-8">
                Smart TV Applications
              </h2>
              <div className="space-y-6">
                <p className="text-lg text-gray-600 leading-relaxed">
                  Transform your living room into the ultimate sports viewing experience. 
                  Our smart TV apps deliver cinema-quality 4K streaming with surround sound support.
                </p>
                
                <div className="grid grid-cols-2 gap-4">
                  {/* Platform Options */}
                  <div className="bg-white rounded-xl p-4 shadow-custom border border-gray-100">
                    <div className="text-center">
                      <div className="w-12 h-12 bg-black rounded-lg flex items-center justify-center mx-auto mb-3">
                        <span className="text-white font-bold text-sm">TV</span>
                      </div>
                      <h3 className="font-semibold text-ibt-gray mb-1">Apple TV</h3>
                      <p className="text-xs text-gray-600">tvOS App</p>
                    </div>
                  </div>
                  
                  <div className="bg-white rounded-xl p-4 shadow-custom border border-gray-100">
                    <div className="text-center">
                      <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center mx-auto mb-3">
                        <span className="text-white font-bold text-sm">YT</span>
                      </div>
                      <h3 className="font-semibold text-ibt-gray mb-1">YouTube TV</h3>
                      <p className="text-xs text-gray-600">Channel App</p>
                    </div>
                  </div>
                  
                  <div className="bg-white rounded-xl p-4 shadow-custom border border-gray-100">
                    <div className="text-center">
                      <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mx-auto mb-3">
                        <span className="text-white font-bold text-sm">RK</span>
                      </div>
                      <h3 className="font-semibold text-ibt-gray mb-1">Roku</h3>
                      <p className="text-xs text-gray-600">Channel Store</p>
                    </div>
                  </div>
                  
                  <div className="bg-white rounded-xl p-4 shadow-custom border border-gray-100">
                    <div className="text-center">
                      <div className="w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center mx-auto mb-3">
                        <span className="text-white font-bold text-sm">FS</span>
                      </div>
                      <h3 className="font-semibold text-ibt-gray mb-1">Fire TV</h3>
                      <p className="text-xs text-gray-600">Amazon Store</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* App Features */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-display font-bold text-ibt-gray mb-4">
              Powerful Features Across All Platforms
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Whether you're on mobile, tablet, or smart TV, enjoy the same premium 
              features and seamless experience across all devices.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Feature Cards */}
            <div className="bg-white rounded-xl p-6 shadow-custom border border-gray-100 hover:shadow-custom-lg transition duration-300">
              <div className="w-12 h-12 bg-ibt-blue rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-ibt-gray mb-3">4K Ultra HD</h3>
              <p className="text-gray-600">
                Experience every detail with crystal-clear 4K resolution and HDR support 
                for the most immersive viewing experience.
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-custom border border-gray-100 hover:shadow-custom-lg transition duration-300">
              <div className="w-12 h-12 bg-ibt-red rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-ibt-gray mb-3">Offline Downloads</h3>
              <p className="text-gray-600">
                Download games and highlights to watch offline when you're traveling 
                or in areas with limited connectivity.
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-custom border border-gray-100 hover:shadow-custom-lg transition duration-300">
              <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 2L3 7v11c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V7l-7-5z"/>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-ibt-gray mb-3">Multi-Device Sync</h3>
              <p className="text-gray-600">
                Start watching on one device and seamlessly continue on another. 
                Your progress syncs automatically across all platforms.
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-custom border border-gray-100 hover:shadow-custom-lg transition duration-300">
              <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 12a2 2 0 100-4 2 2 0 000 4z"/>
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm-3.707-8.293a1 1 0 00-1.414 1.414L7.586 14l-2.293 2.293a1 1 0 101.414 1.414L9 15.414l2.293 2.293a1 1 0 001.414-1.414L10.414 14l2.293-2.293a1 1 0 00-1.414-1.414L9 12.586 6.707 10.293z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-ibt-gray mb-3">Live Notifications</h3>
              <p className="text-gray-600">
                Get instant alerts for game starts, scoring updates, and breaking news 
                for your favorite teams and players.
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-custom border border-gray-100 hover:shadow-custom-lg transition duration-300">
              <div className="w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-ibt-gray mb-3">Customizable Interface</h3>
              <p className="text-gray-600">
                Personalize your viewing experience with customizable layouts, 
                favorite team shortcuts, and tailored content recommendations.
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-custom border border-gray-100 hover:shadow-custom-lg transition duration-300">
              <div className="w-12 h-12 bg-indigo-600 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-ibt-gray mb-3">Multi-User Profiles</h3>
              <p className="text-gray-600">
                Create separate profiles for family members with personalized 
                preferences, watch history, and content recommendations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Download CTA */}
      <section className="section-padding gradient-bg text-white">
        <div className="container-custom text-center">
          <h2 className="text-4xl font-display font-bold mb-6">
            Download IBT Sports Today
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Get started with the ultimate sports streaming experience. 
            Download our apps and never miss a game again.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center max-w-2xl mx-auto">
            {/* App Store Button */}
            <a href="#" className="bg-black text-white px-8 py-4 rounded-lg flex items-center space-x-4 hover:bg-gray-800 transition duration-300 min-w-0 flex-1 sm:flex-initial">
              <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
              </svg>
              <div className="text-left">
                <div className="text-xs">Download on the</div>
                <div className="text-lg font-semibold">App Store</div>
              </div>
            </a>

            {/* Google Play Button */}
            <a href="#" className="bg-black text-white px-8 py-4 rounded-lg flex items-center space-x-4 hover:bg-gray-800 transition duration-300 min-w-0 flex-1 sm:flex-initial">
              <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.523 15.3414c-.5511 0-.9993-.4486-.9993-.9997s.4482-.9993.9993-.9993c.5511 0 .9993.4482.9993.9993.0001.5511-.4482.9997-.9993.9997m-11.046 0c-.5511 0-.9993-.4486-.9993-.9997s.4482-.9993.9993-.9993c.5511 0 .9993.4482.9993.9993 0 .5511-.4482.9997-.9993.9997m11.4045-6.02l1.9973-3.4592a.416.416 0 00-.1521-.5676.416.416 0 00-.5676.1521l-2.0223 3.503C15.5902 8.2439 13.8533 7.8508 12 7.8508s-3.5902.3931-5.1367 1.0989L4.841 5.4467a.4161.4161 0 00-.5677-.1521.4157.4157 0 00-.1521.5676l1.9973 3.4592C2.61 10.2718.8995 12.8447.8995 15.7995c0 .1873.0008.3733.0023.5588v6.6334C.9018 24.8814 2.1204 26.1 3.6107 26.1h16.7785c1.4903 0 2.7089-1.2186 2.7089-2.7083v-6.6334c.0015-.1855.0023-.3715.0023-.5588 0-2.9548-1.7105-5.5277-4.2098-6.4581"/>
              </svg>
              <div className="text-left">
                <div className="text-xs">Get it on</div>
                <div className="text-lg font-semibold">Google Play</div>
              </div>
            </a>
          </div>

          <div className="mt-8 text-blue-200">
            <p className="text-sm">Also available on Smart TV platforms</p>
            <p className="text-xs mt-1">Apple TV • Roku • Fire TV • YouTube TV</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Apps; 